import { Controller } from '@hotwired/stimulus';
import { isVisited } from '../../utils/ad_visit_db_manager';
import { captureException } from '@sentry/browser';
export default class CardManualController extends Controller {
  static values = { adId: String };
  static targets = ['visitedLabel'];

  async connect() {
    if (!this.hasAdIdValue || !this.adIdValue) {
      return;
    }

    try {
      const visited = await isVisited(this.adIdValue);
      if (visited && this.hasVisitedLabelTarget) {
        this.visitedLabelTarget.classList.remove('d-none');
      }
    } catch (error) {
      captureException(error);
    }
  }
}
